import { scroll, animate } from 'motion'

let scrollTarget = document.querySelectorAll('[data-scroll-in]')

scrollTarget.forEach((item) => {
    scroll(animate(item,
            { opacity: [0, 1, 1, 0], scale: [0.8, 1, 1, 0.8] },
            { ease: 'linear' }
        ), {
            target: item,
            // offset: ["start end", "75% end", "25% start", "end start"],
            offset: ["start end", "end end", "start start", "end start"],
        })
})
